import { Component } from '@angular/core';

@Component({
    selector: 'mas-corominola',
    template: require('./mas-corominola.component.html'),
})

export class MasCorominolaComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/mas_corominola/mas-corominola.component.ts
 **/